import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "@/components/AuthProvider";

export default function AppShell() {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <nav className="bg-[#09090B]/80 backdrop-blur-md border-b border-zinc-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between min-h-14 py-2 gap-4">
            <div className="flex items-center gap-6 flex-wrap">
              <span className="text-amber-500 font-bold text-lg">KCG</span>
              <div className="flex items-center gap-1 flex-wrap">
                <NavLink
                  to="/"
                  end
                  data-testid="nav-dashboard"
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                      isActive
                        ? "bg-zinc-800 text-zinc-100"
                        : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                    }`
                  }
                >
                  Dashboard
                </NavLink>
                <NavLink
                  to="/history"
                  data-testid="nav-history"
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                      isActive
                        ? "bg-zinc-800 text-zinc-100"
                        : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                    }`
                  }
                >
                  History
                </NavLink>
                <NavLink
                  to="/templates"
                  data-testid="nav-templates"
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                      isActive
                        ? "bg-zinc-800 text-zinc-100"
                        : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                    }`
                  }
                >
                  Templates
                </NavLink>
                <NavLink
                  to="/jobs"
                  data-testid="nav-jobs"
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                      isActive
                        ? "bg-zinc-800 text-zinc-100"
                        : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                    }`
                  }
                >
                  Jobs
                </NavLink>
              </div>
            </div>

            <div className="flex items-center gap-3 ml-auto">
              <span className="text-xs md:text-sm text-zinc-400 font-mono">
                {user?.email}
              </span>
              <button
                type="button"
                onClick={handleLogout}
                className="px-3 py-2 rounded-md text-sm font-medium bg-zinc-800 text-zinc-100 hover:bg-zinc-700 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <Outlet />
    </>
  );
}
